import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground mt-20" data-testid="site-footer">
      <div className="container-le py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="font-heading text-2xl font-semibold tracking-tight">Lake Eunice Township</div>
          <p className="text-sm text-primary-foreground/70 mt-3 leading-relaxed max-w-xs">
            A close-knit lake community in Becker County, Minnesota. This site keeps residents informed of township business, meetings, and notices.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-primary-foreground/60 mb-4">Reach Us</div>
          <div className="flex items-start gap-3 text-sm mb-3">
            <MapPin size={16} className="mt-0.5 shrink-0" />
            <span>12708 Townhall Rd<br />Audubon, MN 56511</span>
          </div>
          <div className="flex items-center gap-3 text-sm">
            <Mail size={16} />
            <a className="link-underline" href="mailto:Lakeeunicetwp@gmail.com">Lakeeunicetwp@gmail.com</a>
          </div>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-primary-foreground/60 mb-4">Township</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="link-underline" to="/board">Township Board</Link></li>
            <li><Link className="link-underline" to="/postings">Public Notices</Link></li>
            <li><Link className="link-underline" to="/minutes">Meeting Minutes</Link></li>
            <li><Link className="link-underline" to="/calendar">Calendar</Link></li>
            <li><Link className="link-underline" to="/contact">Contact Us</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-le py-5 text-xs flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-primary-foreground/60">
          <span>© {new Date().getFullYear()} Lake Eunice Township. All rights reserved.</span>
          <a
            href="https://frostbyteitmn.com"
            target="_blank"
            rel="noreferrer"
            data-testid="powered-by-frostbyte"
            className="group inline-flex items-center gap-2.5 px-3 py-1.5 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 transition-colors"
          >
            <span className="uppercase tracking-[0.2em] text-[10px] text-primary-foreground/60 group-hover:text-primary-foreground/80">
              Powered by
            </span>
            <img
              src="https://customer-assets.emergentagent.com/job_frosty-it-hub/artifacts/o2t5vwwy_logo.jpeg"
              alt="FrostByte IT"
              className="h-6 w-6 rounded-full object-cover ring-1 ring-white/20"
            />
            <span className="font-semibold text-primary-foreground/85 group-hover:text-primary-foreground">
              FrostByte IT
            </span>
            <span className="text-primary-foreground/40">·</span>
            <span className="text-primary-foreground/60 group-hover:text-primary-foreground/85">
              frostbyteitmn.com
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
